var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuVerificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "verification-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M1.962,4.935A1.15,1.15,0,0,0,.337,6.561Zm3.785,5.411-.813.813a1.15,1.15,0,0,0,1.626,0ZM15.757,1.962A1.15,1.15,0,0,0,14.131.337ZM.337,6.561l4.6,4.6L6.561,9.533l-4.6-4.6Zm6.224,4.6,9.2-9.2L14.131.337l-9.2,9.2Z",
    transform: "translate(4 6.252)",
    fill: "#6b6b95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVerificationIcon);
export default __webpack_public_path__ + "static/media/menuVerificationIcon.fc8e449cd791664221e1ee2d985a03fe.svg";
export { ForwardRef as ReactComponent };